import { render, staticRenderFns } from "./VerifiedSoc.vue?vue&type=template&id=7185c360&scoped=true"
import script from "./VerifiedSoc.vue?vue&type=script&lang=js"
export * from "./VerifiedSoc.vue?vue&type=script&lang=js"
import style0 from "./VerifiedSoc.vue?vue&type=style&index=0&id=7185c360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7185c360",
  null
  
)

export default component.exports